var map = {
	"./logo-asm.png": 3389,
	"./logo-callout-thegame.png": 9084,
	"./logo-clermontfoot.png": 7348,
	"./logo-jumpingjoy.png": 4124,
	"./logo-michelin.png": 8039,
	"./logo-originskrew.png": 3010
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6132;